// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"607":"6517a843","883":"7f0843f5"}[chunkId] + ".chunk.js";
};